import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import CategoryLists from '../components/Manager/PostCategories/CategoryLists';
import { getAllCategoriesWebSys } from '../redux/actions/categoriesActions';
import Common from '../components/Common';
import InputBase from '@material-ui/core/InputBase';
import SearchIcon from '@material-ui/icons/Search';

const styles = theme => ({
  ...theme,
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
  },
  button: {
    margin: theme.spacing.unit,
  },
  container: {
    margin: "20px auto 50px",
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: '#222',
    '&:hover': {
      backgroundColor: '#333',
    },
    width: '100%',
    maxWidth: 960,
    margin: '15px auto 0',
  },
  searchIcon: {
    width: theme.spacing.unit * 9,
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
    width: '100%',
  },
  inputInput: {
    paddingTop: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    paddingLeft: theme.spacing.unit * 10,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: 200,
    },
  },
})

class PostCategories extends Component {
    constructor(props) {
      super(props);
      this.state = {
        name: '',
        page: 0,
        rowsPerPage: 10,
      }
  }

  handleChangePage = (event, page) => {
      this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
      this.setState({ page: 0, rowsPerPage: event.target.value });
  };

  componentDidMount() {
    if(this.props.categories.categories_web_sys.length === 0) {
      this.props.getAllCategoriesWebSys();
    }
  }
  handleChange = (event) => {
    this.setState({
        [event.target.name]: event.target.value
    })
  };
  render() {
    const { categories_web_sys } = this.props.categories;
    const { classes, loading } = this.props;
    const { rowsPerPage, page, name  } = this.state;
    var categories = categories_web_sys;
    categories = categories.filter(category => {
      return category.domain === 'ntea.vn'
    } )
    categories = categories.filter(category => {
      return category.name.vi.toLowerCase().indexOf(name.toLowerCase()) !== -1
    } )
    // const emptyRows = rowsPerPage - Math.min(rowsPerPage, categories_web_sys.length - page * rowsPerPage);

    let recentQRCodeMarkup = !loading ? (
      categories.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((category, index) => 
            <CategoryLists key={index} index={index+1} category={category} />
        )
  ) : ( 
    <tr>
      <td colSpan="8" className="alignCenter"><i className="fas fa-spinner fa-pulse fa-2x textWarning" /></td>
    </tr>
  );
    return (
      <Fragment>
        <Common isCategories={true} />
        <div className={classes.search}>
          <div className={classes.searchIcon}>
            <SearchIcon />
          </div>
          <InputBase
            name="name"
            placeholder="Tìm chuyên mục"
            classes={{
              root: classes.inputRoot,
              input: classes.inputInput,
            }}
            onChange={this.handleChange}
          />
        </div>
        <div className={classes.container}>
                <div className="table mt-15">
                  <table>
                    <thead>
                      <tr>
                        <td>
                          STT
                        </td>
                        <td>
                          Ảnh
                        </td>
                        <td>
                          Tên chuyên mục
                        </td>
                        <td>
                          Thư mục cha
                        </td>
                        <td>
                          Chuỗi cho đường dẫn tĩnh
                        </td>
                        <td className="alignCenter">
                          Ưu tiên
                        </td>
                        <td>
                          Hành động
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      {recentQRCodeMarkup}
                      {categories.length > rowsPerPage &&
                      <tr>
                        <td colSpan="8" className="alignCenter"><button className="button" onClick={() => this.setState({rowsPerPage: this.state.rowsPerPage+10})}>Xem thêm</button></td>
                      </tr>
                      }
                    </tbody>
                  </table>
                </div>
            </div>
      </Fragment>
    )
  }
}

PostCategories.propTypes = {
    getAllCategoriesWebSys: PropTypes.func.isRequired,
    categories: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
    categories: state.categories,
    loading: state.UI.loading
})

export default connect(mapStateToProps, { getAllCategoriesWebSys })(withStyles(styles)(PostCategories));